import ExpansesList from "./ExpensesList";

export default ExpansesList;
